"use client";
import { RiLock2Line } from "react-icons/ri";
import { StarRating } from "~/app/community-management/[communitySlug]/host-feedback/_components/StarRating";
import { If } from "~/components/v3/Conditional";
import { TooltipContent } from "~/components/v3/shadcn/Tooltip";
import { Card, CardContent, CardHeader } from "~/components/v3/shadcn/Card";
import { TooltipTrigger } from "~/components/v3/shadcn/Tooltip";
import { TooltipProvider } from "~/components/v3/shadcn/Tooltip";
import { Tooltip } from "~/components/v3/shadcn/Tooltip";

import { RATE_THRESHOLD } from "~/utils/constants";
import { useState } from "react";
const HostRating = ({
    rate,
    reviewCount,
    showHeader = true,
}: {
    rate: number;
    reviewCount: number;
    showHeader?: boolean;
}) => {
    if (!rate || !reviewCount) return null;

    if (rate < RATE_THRESHOLD) {
        return null;
    }

    return (
        <div className="max-h-[180px]">
            <If condition={showHeader}>
                <div>
                    <a href="#hosting-reviews">
                        <h3 className="text-base font-[400] text-v3-N300">
                            Host rating
                        </h3>
                    </a>
                </div>
            </If>

            <CardContent className="p-0">
                <div className="flex flex-col gap-2">
                    <h2 className="leading-0">{rate.toFixed(1)}</h2>
                    <StarRating size={17} rating={rate} />
                    <p className="mt-2 text-sm text-gray-400">
                        Based on {reviewCount.toLocaleString()} verified reviews
                    </p>
                </div>
            </CardContent>
        </div>
    );
};

export const HostRatingTooltip = () => {
    const [isTooltipOpen, setIsTooltipOpen] = useState(false);
    return (
        <TooltipProvider delayDuration={0}>
            <Tooltip
                open={isTooltipOpen}
                onOpenChange={(val) => setIsTooltipOpen(val)}
            >
                <TooltipTrigger>
                    <div className="flex items-center justify-center rounded-md bg-[#373A41] p-[5px]">
                        <RiLock2Line className="h-4 w-4 text-white" />
                    </div>
                </TooltipTrigger>
                <TooltipContent sideOffset={-100}>
                    <p className="text-[12px]">Only visible to you</p>
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};

export default HostRating;
